import { SearchResultI } from "./searchHooks";

export const hasPreview = (result: SearchResultI): boolean => {
    if (result.kenmerk != 'Downloadbaar bestand') return false;
    return true;
};